import {
  H1Plugin,
  H2Plugin,
  H3Plugin,
  H4Plugin,
  H5Plugin,
  H6Plugin,
  HeadingPlugin,
} from '@platejs/basic-nodes/react'
import { HeadingRules } from '@platejs/basic-nodes'
import type { HeadingLevel } from '@platejs/basic-nodes'

import {
  H1Element,
  H2Element,
  H3Element,
  H4Element,
  H5Element,
  H6Element,
} from './HeadingElement'

const RichTextFieldH1Plugin: typeof H1Plugin = H1Plugin.withComponent(H1Element)
const RichTextFieldH2Plugin: typeof H2Plugin = H2Plugin.withComponent(H2Element)
const RichTextFieldH3Plugin: typeof H3Plugin = H3Plugin.withComponent(H3Element)
const RichTextFieldH4Plugin: typeof H4Plugin = H4Plugin.withComponent(H4Element)
const RichTextFieldH5Plugin: typeof H5Plugin = H5Plugin.withComponent(H5Element)
const RichTextFieldH6Plugin: typeof H6Plugin = H6Plugin.withComponent(H6Element)

const headingLevels: HeadingLevel[] = [1, 2, 3, 4, 5, 6]
const headingPluginsByLevel = {
  1: RichTextFieldH1Plugin,
  2: RichTextFieldH2Plugin,
  3: RichTextFieldH3Plugin,
  4: RichTextFieldH4Plugin,
  5: RichTextFieldH5Plugin,
  6: RichTextFieldH6Plugin,
}

const RichTextFieldHeadingPlugin: typeof HeadingPlugin = HeadingPlugin.extend(
  ({ plugin }) => {
    const levels = Array.isArray(plugin.options.levels)
      ? plugin.options.levels
      : headingLevels.slice(0, plugin.options.levels ?? headingLevels.length)

    return { plugins: levels.map((level) => headingPluginsByLevel[level]) }
  },
)

const createRichTextFieldHeadingInputRule = HeadingRules.markdown

export { HeadingElement } from './HeadingElement'
export type { HeadingElementProps, HeadingElementTag } from './HeadingElement'
export {
  RichTextFieldH1Plugin,
  RichTextFieldH2Plugin,
  RichTextFieldH3Plugin,
  RichTextFieldH4Plugin,
  RichTextFieldH5Plugin,
  RichTextFieldH6Plugin,
  RichTextFieldHeadingPlugin,
  createRichTextFieldHeadingInputRule,
}
